<template>
<div id="container" class="skigeschichten">
    <div class="fullscreen_background">
        <img src="/static/assets/skigeschichten/Hintergrund_2860.jpg" />
    </div>
    <top-menu />
    <schnee :amount="500" :size="4" :speed="1.5" :wind="0" :opacity="0.8" :swing="1" :image="null" :zIndex="null" :resize="true" color="#fff" />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
    <!-- <div class="moeve z30 hovering">
        <img class="img" src="/static/assets/skigeschichten/Moeve.png" />
    </div> -->
 <div class="schnee z49">
        <img class="img" src="/static/assets/skigeschichten/Gold_Gigi_2880zu1620_02-01.png" />
    </div>
    <div class="bus bus_erscheint z30">
        <!-- <img class="img" src="/static/assets/skigeschichten/Schwimmer.png" /> -->
        <!-- <img class="img" src="/static/assets/skigeschichten/Bus.png" /> -->
		<div class="bus_animation"></div>
    </div>
    <div class="seilbahn z30">
        <!-- <img class="img" src="/static/assets/skigeschichten/Seilbahn.png" /> -->
		<div class="lift_animation"></div>
    </div>
    <div class="steuermann z30">
        <img class="img" src="/static/assets/skigeschichten/Louis.png" />
    </div>
    <!-- <div class="koechin z30">
        <img class="img" src="/static/assets/skigeschichten/Koechin.png" />
    </div> -->
    <div class="libero z30">
        <img class="img" src="/static/assets/skigeschichten/Libero.png" />
    </div>
    <div class="hui z30">
        <img class="img" src="/static/assets/skigeschichten/Hugi.png" />
    </div>
    <div class="dubix z30">
        <img class="img" src="/static/assets/skigeschichten/Pistenfahnen.png" />
    </div>
    <div class="gigikaeptn gigikaeptn_animation z30">
        <!-- <img class="img" src="/static/assets/skigeschichten/Gigi_Kaeptn.png" /> -->
    </div>
    <!-- <div class="schild z34">
        <img class="img" src="/static/assets/skigeschichten/Schild.png" />
    </div> -->
    <div class="vogel z35">
        <img class="img" src="/static/assets/skigeschichten/Vogel.png" />
    </div>
	 <div class="schild z50">
        <img class="img" src="/static/assets/skigeschichten/Schild.png" />
    </div>
	 <div class="haus z47">
        <!-- <img class="img" src="/static/assets/skigeschichten/Haus.png" /> -->
		 <div class="haus_animation"></div>
    </div>
	 <div class="schneemann">
        <img class="img" src="/static/assets/skigeschichten/Schneemann.png" />
    </div>


    <router-link to="/zirkusgeschichten" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/skigeschichten/Pfeil.png" />
    </router-link>

    <router-link to="/djgeschichten" tag="div" class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/skigeschichten/Pfeil-1.png" />
    </router-link>

    <div class="geschichte z50">
        <img src="/static/assets/skigeschichten/Gold-Gigi.png" usemap="#geschichte-map">
        <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Geschichte_1_Gold_Gigi.mp3" jsonurl="/static/assets/geschichten/gigi_28_11.timings.json" content=".skigeschichten" target="skigeschichten_target"/>
        <!-- // eslint-disable-next-line -->
      <vuescrollbar tag="div" class="fliesstext" id="skigeschichten_target">
        <p>Gold-Gigi, Loipen-Hugi, Alpin-Dubix, Schwarzpisten-Nici und Speedy Felix schwangen sich aus dem Lift. Vor ihnen lag die Piste, auf der sich die abfahrenden Skifahrer wie flinke Ameisen im Riesenslalom bergab bewegten. Man konnte sie kaum mehr erkennen, denn es schneite immer mehr. Für heute musste das die letzte Abfahrt sein. Es war zu gefährlich weiterzufahren, wenn man nicht genug sah. „Los!“, rief ihr Skilehrer Luis. „Legen wir los! Sonst verpasst ihr den Bus.“</p>
<p>Sie erreichten den Bus zu ihrer Skihütte gerade rechtzeitig. Skilehrer Luis wünschte ihnen noch einen schönen Tag und versprach, sie morgen früh wieder an der Bushaltestelle abzuholen. Der Busfahrer schimpfte über den vielen Schnee: „Das wird meine letzte Fahrt für heute, ich komme kaum mehr durch — trotz Schneeketten!“ Die Freunde waren froh, als sie die warme Hütte erreichten. Hüttenhund Libero begrüßte sie freudig. Doch nanu — wo war die Wirtin Josefa Finkenhuber? Im Kamin prasselte das Feuer. Lange konnte Josefa also noch nicht weg sein. Wahrscheinlich war sie noch losgefahren, um schnell etwas einzukaufen. Sie hatte versprochen, heute Abend Germknödel zu kochen. Mmmhh! Aber Josefa kam nicht. Die Freunde blickten beunruhigt aus dem Fenster. Draußen war es schon finster, es schneite und schneite, die Schneedecke wuchs und wuchs. Libero winselte, doch kein Mensch war zu sehen. Sie hatten riesigen Hunger! „Kommt!“, rief Gold-Gigi schließlich. „Gucken wir in die Speisekammer! Ich kenne Josefa gut, sie hat bestimmt nichts dagegen.“ In dem winzigen Raum stapelten sich die Vorräte. Josefa war einmal für ein paar Tage in der Hütte eingeschneit gewesen und seitdem füllte sie die Speisekammer immer randvoll. Die fünf nahmen sich Brot, Speck und Käse und setzten sich an den großen Küchentisch. „Wo bleibt Josefa nur?“, fragte Loipen-Hugi schmatzend in die Runde. „Ja, wie viel Uhr ist es eigentlich?“, fügte Alpin-Dubix hinzu und blickte auf sein Handy. „Oh!“, stellte er erschrocken fest. „Kein Empfang mehr. Das liegt sicher am vielen Schnee, wir können ja mal Radio hören.“ Was das Radio meldete, ließ die Freunde erstmal vor Schreck verstummen. Die Masse an Neuschnee hatte für Lawinengefahr gesorgt und jetzt waren alle Straßen rundum gesperrt! Sie waren praktisch eingeschneit! „Wie Josefa damals …“, flüsterte Speedy Felix beklommen. „Oooh, was machen wir jetzt?“, schluchzte Schwarzpisten-Nici ganz verzweifelt. „Also, verhungern werden wir so schnell nicht, Brennholz haben wir mehr als genug und wenn der Strom ausfällt …“ Gold-Gigi kam nicht dazu, den Satz zu beenden. Denn die Lampe begann zu flackern und — oweiowei — mit einem Mal saßen sie im Stockdunklen! </p>
<p>„Keine Panik!“, rief Gold-Gigi trotzig, obwohl auch ihr langsam mulmig wurde. „Auch dafür hat Josefa vorgesorgt!“ Sie tastete sich zur Schublade des Holztisches, zog eine Taschenlampe heraus und schaltete sie ein. „So“, sagte sie, „das ist noch nicht alles.“ Sie ging zum Küchenschrank, öffnete ihn, verteilte Taschenlampen und zündete eine Petroleumlampe an, die den Raum sofort erhellte. Als sie den Schrank schließen wollte, blieb ihr Blick an einem Buch hängen. „Märchen aus aller Welt“ las sie den Titel des dicken Bandes. Gold-Gigi zeigte ihn den anderen und sie beschlossen, es sich im Matratzenlager gemütlich zu machen und sich aus dem Buch vorzulesen. Das taten sie dann auch. Abwechselnd las jeder ein Märchen vor und dabei vergaßen sie, dass sie eingeschneit waren. Das ging die ganze Nacht, bis einer nach dem anderen einschlief. Gold-Gigi las als Letzte vor. Als sie merkte, dass sie keine Zuhörer mehr hatte, löschte sie das Petroleumlicht, kuschelte sich an Libero und schlief ein.</p>
<p>Am nächsten Morgen arbeitete sich ein Schneepflug langsam zur Hütte vor. Ihm folgte das Auto von Josefa Finkenhuber. Als sie die Hütte betrat, schliefen alle noch tief und fest. Erleichtert streichelte sie der träumenden Gold-Gigi über den Kopf. Die murmelte wohlig und glücklich: </p>
<p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
import Snowf from 'vue-snowf'
// import Scrollbar from 'jquery.scrollbar'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'Skigeschichten',
  data () {
    return {
      who: 'Skigeschichten'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'schnee': Snowf,
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () {
    this.$ga.page(this.$router)
    var muted = (typeof window.muted === 'undefined' ? false : window.muted)
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Archivseite_Gigi_Titel_A1902.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }
      window.hintergrundSound = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_ski_Atmo_II.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined' ? window.muted : false)
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e)  {
        window.bgsounddisabled = true
      }
    }, 1000)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
    console.log('hintergrundsound nicht aktiv')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::-webkit-scrollbar { background: none !important; }
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

/* skigeschichten */
.skigeschichten { position: absolute; width: 1920px; height: 1080px; bottom: 0; }

.skigeschichten .himmel { display: block !important; }

.skigeschichten .geschichte {
	position: absolute;
    top: 170px;
    left: 52%;
}

.skigeschichten .pfeil_links_big {position: absolute; left: 1vw; top: 40%;}
.skigeschichten .pfeil_rechts_big {position: absolute; right: 1vw; top: 40%;}

/* .skigeschichten .bus {position: absolute; left: 28%; top: 39%; } */
.skigeschichten .bus {
	position: absolute;
    left: 17%;
    top: 41%;
	opacity: 1;
}
.bus_erscheint {animation: bus_erscheint_animation 10s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes bus_erscheint_animation {
    0% {margin-left: 400px; opacity:0;}
    25% { opacity:1;}
    100% {margin-left: 0px; opacity:1;}
}
.skigeschichten .seilbahn {position: absolute;
    left: 24%;
    bottom: 49%;
}

.skigeschichten .vogel {position: absolute; /* left:0; bottom: -5px;*/    left: 6%;    bottom: 19%;}
.skigeschichten .steuermann {position: absolute; left: 12%; bottom: 43%;}
.skigeschichten .steuermann {animation: steuermann_erscheint 0.5s ease-out; animation-delay: 1.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-left: -270px; */}
@keyframes steuermann_erscheint {
    /* 50% {margin-left: -270px;opacity:0;}
    100% {margin-left: 0px; opacity:1;} */
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.skigeschichten .koechin {position: absolute; left: 37%; bottom: 26%;}
.skigeschichten .hui {
	position: absolute;
    right: 78%;
    bottom: 15%;
}
	.skigeschichten .haus {
    position: absolute;
    left: 42%;
    bottom: -21%;
}
	.skigeschichten .schnee {
    position: absolute;
    top: -26%;
    left: -25%;
	}
.skigeschichten .hui {animation: hui_erscheint 0.5s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hui_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.skigeschichten .dubix {position: absolute;
    left: 1%;
    bottom: 25%;
}
.skigeschichten .dubix {animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.75s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
	.skigeschichten .schneemann {
    position: absolute;
    left: 89%;
    bottom: 26%;
}
.skigeschichten .snowf-canvas {
    position: absolute;
    left: -25%;
    top: 0;
    width: 150%;
    height: 150%;
}
.skigeschichten .libero {position: absolute; left: 26%; bottom: 17%;}
.skigeschichten .libero {animation: libero_erscheint 0.5s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes libero_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.skigeschichten .gigikaeptn {position: absolute; /* left: 23%; bottom: 6%; */ left: 22%; bottom: 16%; }
/* .skigeschichten .gigikaeptn_animation {animation: gigikaeptn_erscheint 0.5s ease-out; animation-delay: 0s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes gigikaeptn_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
} */
.skigeschichten .moeve { position: absolute; top: 250px; left: 600px; }
.skigeschichten .schild { position: absolute;
    bottom: 67px;
    left: 670px; }
.fliesstext{
    bottom: 25%;
    left: 10.5%;
    width: 79%;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
    position: absolute;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 450px;
    padding-right: 15px;
}
.lift_animation {
  width: 675px;
  height: 404px;
  background: url('/static/assets/skigeschichten/lift_animation.png') top center;
  animation-delay: 2s;
  animation: lift_animation_swing 2s steps(13) infinite;
  /* transform: scale(0.85);
  margin-top: -65px; */
}

@keyframes lift_animation_swing {
  100% {
    background-position: 0 -5252px;
  }
}
  
.haus_animation {
  width: 345px;
  height: 848px;
  background: url('/static/assets/skigeschichten/haus_animation.png') top center;
  animation-delay: 2s;
  animation: haus_animation_ball 6s steps(14) infinite;
  /* transform: scale(0.85);
  margin-top: -65px; */
}

@keyframes haus_animation_ball {
  50% {
    background-position: 0 -11872px;
  }
  100% {
    background-position: 0 -11872px;
  }
}

.bus_animation {
  width: 497px;
  height: 317px;
  background: url('/static/assets/skigeschichten/bus_animation.png') top center;
  animation-delay: 2s;
  animation: jongleur_animation 4s steps(5) infinite;
  /* transform: scale(0.85);
  margin-top: -65px; */
}

@keyframes jongleur_animation {
  100% {
    background-position: 0 -1585px;
  }
}
/* möve animation */

@-webkit-keyframes hovering /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,20px);
    -moz-transform: translate(20px,20px);
    -webkit-transform: translate(20px,20px);
    -o-transform: translate(20px,20px);
    transform: translate(20px,20px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.skigeschichten .hovering {
  -webkit-animation: hovering 20s linear infinite;
  -moz-animation: hovering 20s linear infinite;
  -ms-animation: hovering 20s linear infinite;
  -o-animation: hovering 20s linear infinite;
  animation: hovering 20s linear infinite;
}

/* bus animation */
@-webkit-keyframes hovering2 /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering2 {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,0px);
    -moz-transform: translate(20px,0px);
    -webkit-transform: translate(20px,0px);
    -o-transform: translate(20px,0px);
    transform: translate(20px,0px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.skigeschichten .hovering2 {
  -webkit-animation: hovering2 10s linear infinite;
  -moz-animation: hovering2 10s linear infinite;
  -ms-animation: hovering2 10s linear infinite;
  -o-animation: hovering2 10s linear infinite;
  animation: hovering2 10s linear infinite;
}

/*************** SCROLLBAR BASE CSS ***************/

.scroll-wrapper {
    overflow: hidden !important;
    padding: 0 !important;
    position: relative;
}

.scroll-wrapper > .scroll-content {
    border: none !important;
    box-sizing: content-box !important;
    height: auto;
    left: 0;
    margin: 0;
    max-height: none;
    max-width: none !important;
    overflow: scroll !important;
    padding: 0;
    position: relative !important;
    top: 0;
    width: auto !important;
}

.scroll-wrapper > .scroll-content::-webkit-scrollbar {
    height: 0;
    width: 0;
}

.scroll-element {
    display: none;
}
.scroll-element, .scroll-element div {
    box-sizing: content-box;
}

.scroll-element.scroll-x.scroll-scrollx_visible,
.scroll-element.scroll-y.scroll-scrolly_visible {
    display: block;
}

.scroll-element .scroll-bar,
.scroll-element .scroll-arrow {
    cursor: default;
}

.scroll-textarea {
    border: 1px solid #cccccc;
    border-top-color: #999999;
}
.scroll-textarea > .scroll-content {
    overflow: hidden !important;
}
.scroll-textarea > .scroll-content > textarea {
    border: none !important;
    box-sizing: border-box;
    height: 100% !important;
    margin: 0;
    max-height: none !important;
    max-width: none !important;
    overflow: scroll !important;
    outline: none;
    padding: 2px;
    position: relative !important;
    top: 0;
    width: 100% !important;
}
.scroll-textarea > .scroll-content > textarea::-webkit-scrollbar {
    height: 0;
    width: 0;
}

/*************** SIMPLE INNER SCROLLBAR ***************/

.scrollbar-inner > .scroll-element,
.scrollbar-inner > .scroll-element div
{
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    z-index: 10;
}

.scrollbar-inner > .scroll-element div {
    display: block;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
}

.scrollbar-inner > .scroll-element.scroll-x {
    bottom: 2px;
    height: 8px;
    left: 0;
    width: 100%;
}

.scrollbar-inner > .scroll-element.scroll-y {
    height: 100%;
    right: 2px;
    top: 0;
    width: 8px;
}

.scrollbar-inner > .scroll-element .scroll-element_outer {
    overflow: hidden;
}

.scrollbar-inner > .scroll-element .scroll-element_outer,
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
}

.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
    filter: alpha(opacity=40);
    opacity: 0.4;
}

.scrollbar-inner > .scroll-element .scroll-element_track { background-color: #e0e0e0; }
.scrollbar-inner > .scroll-element .scroll-bar { background-color: #c2c2c2; }
.scrollbar-inner > .scroll-element:hover .scroll-bar { background-color: #919191; }
.scrollbar-inner > .scroll-element.scroll-draggable .scroll-bar { background-color: #919191; }

/* update scrollbar offset if both scrolls are visible */

.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track { top: -12px; }

.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size { top: -12px; }

::-webkit-scrollbar {
    width: 15px;
}

::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px #ac8a69;
    box-shadow: inset 0 0 0px #ac8a69;
    -webkit-border-radius: 0;
    border-radius: 0;
}

::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #ac8a69;
}
::-webkit-scrollbar-thumb:window-inactive {
    background: #ac8a69;
}
::-webkit-scrollbar-button {
    background: none;
}
::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat;
}

/* .gigikaeptn_animation {
  width: 350px;
  height: 350px;
  background: url('/static/assets/skigeschichten/Gigi_Kaeptn_Sprite.png') top center;
  animation-delay: 2s;
  animation: gigikaeptn_dubix 4s steps(15) infinite;
  transform: scale(1);
  margin-top:-25px;
} */

@keyframes gigikaeptn_dubix {
    100% { background-position: 0 -5250px; }
}
span { font-family: FrozenMemory; }
.geschichte .player { top: 644px !important; }
</style>



// WEBPACK FOOTER //
// src/components/Skigeschichten.vue